
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Mail } from "lucide-react";

interface ResetFormProps {
  email: string;
  loading: boolean;
  onEmailChange: (val: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const ResetForm: React.FC<ResetFormProps> = ({
  email,
  loading,
  onEmailChange,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className="space-y-4">
    {/* Email Input */}
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Mail className="h-5 w-5 text-white/40" />
      </div>
      <Input
        autoFocus
        type="email"
        placeholder="Email da conta"
        value={email}
        autoComplete="username"
        onChange={(e) => onEmailChange(e.target.value)}
        required
        className="pl-10 bg-white/10 border-white/10 text-white placeholder:text-white/40 focus:border-[#00B6F0]/50 focus:ring-1 focus:ring-[#00B6F0]/50"
      />
    </div>
    
    {/* Submit Button */}
    <Button 
      type="submit" 
      className="w-full bg-[#00B6F0] hover:bg-[#00B6F0]/90 text-white shadow-lg shadow-[#00B6F0]/20 rounded-xl" 
      disabled={loading}
    >
      {loading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Enviando...
        </>
      ) : (
        "Enviar link de redefinição"
      )}
    </Button>
  </form>
);

export default ResetForm;
